import { render, staticRenderFns } from "./create-defend.vue?vue&type=template&id=068e2f03"
import script from "./create-defend.vue?vue&type=script&lang=js"
export * from "./create-defend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports